import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import styled from 'styled-components';

const StyledDesktopContainer = styled.div`
  width: 563px;
  color: ${tokens.ColorWhite000};
  font-size: 32px;
  line-height: 1.25;
  letter-spacing: -0.75px;
  font-family: Nimbus Sans Light;

  @media (max-width: 1024px) {
    width: 448px;
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    width: 450px;
  }
  @media (max-width: 768px) {
    width: 100%;
    font-size: 24px;
    line-height: 1.33;
    letter-spacing: -0.5px;
  }
  .on-track {
    font-family: Nimbus Sans Bold;
    color: ${tokens.ColorFunctionalGreen300};
  }
  .off-track {
    font-family: Nimbus Sans Bold;
    color: ${tokens.ColorFunctionalGold300};
  }
`;

interface OnOffTrackMessageProps {
  onTrack: string;
  offTrack: string;
  valueFromReduxState?: string;
  push?: (path: any) => void;
}

class OnOffTrackMessage extends Component<OnOffTrackMessageProps> {
  props: any;
  render(): JSX.Element {
    const {
      onTrackMessage,
      offTrackMessage,
      simulationCurrentWant: { runoutAge, simulationType },
    } = this.props;

    if (runoutAge > 0) {
      (window as any).metricsData.user.rixStatus = 'off track';
    } else {
      (window as any).metricsData.user.rixStatus = 'on track';
    }

    return (
      <React.Fragment>
        <StyledDesktopContainer
          tabIndex={0}
          dangerouslySetInnerHTML={{
            __html: simulationType ? (runoutAge > 0 ? offTrackMessage : onTrackMessage) : '',
          }}
        />
      </React.Fragment>
    );
  }
}

function mapStateToProps({ charts }: any) {
  return { simulationCurrentWant: charts.simulationCurrentWant };
}

export default connect(mapStateToProps, null)(OnOffTrackMessage);
